<script setup lang="ts">
    import { BUTTON_CLASSES } from '@/config.components';
    import { computed } from 'vue';

    const {
        variant = 'outlined',
        stick = undefined,
        submit = false,
        disabled = false,
        dataTest = 'button-base',
        defaultClasses = true,
    } = defineProps<{
        variant?: 'outlined' | 'filled' | 'text';
        stick?: keyof (typeof BUTTON_CLASSES)['stick'];
        submit?: boolean;
        disabled?: boolean;
        dataTest?: string;
        defaultClasses?: boolean;
    }>();

    const buttonType = computed(() => (submit ? 'submit' : 'button'));

    const buttonClass = computed(() =>
        [
            ...(defaultClasses ? BUTTON_CLASSES.common : []),
            ...(disabled ? BUTTON_CLASSES.disabled : []),
            ...(stick ? BUTTON_CLASSES.stick[stick] : []),
            ...Object.values(BUTTON_CLASSES.types[variant]),
        ].join(' '),
    );
</script>

<template>
    <button
        :class="[buttonClass, $attrs.class]"
        :type="buttonType"
        :disabled
        :data-test
        v-bind="$attrs"
    >
        <slot>Button</slot>
    </button>
</template>
